import styled, { ThemeProvider } from 'styled-components'

import {
  darkBlueTheme,
  lightTheme,
  lightOrangeTheme,
  lightGreyTheme,
  darkPurpleTheme,
  theme as fullTheme,
} from 'lib/theme'

type Props = {
  className?: string
  colorTheme?: string | number
  children: React.ReactNode
}

export const Theme: React.FC<Props> = ({
  className,
  colorTheme = 'light',
  children,
  ...props
}) => {
  const themes: Record<string, typeof lightTheme> = {
    light: lightTheme,
    'dark-blue': darkBlueTheme,
    'light-orange': lightOrangeTheme,
    'light-grey': lightGreyTheme,
    'dark-purple': darkPurpleTheme,
  }

  return (
    // This `theme` is associated with styled-components TODO: remove it later
    <ThemeProvider theme={{ ...fullTheme, colors: themes[colorTheme] }}>
      {/* This `data-theme` is associated to Tailwind CSS */}
      <Wrapper
        data-theme={colorTheme === 'light' ? 'light' : 'dark'}
        {...props}
        className={className}
      >
        {children}
      </Wrapper>
    </ThemeProvider>
  )
}

const Wrapper = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.background.default};
  color: ${({ theme }) => theme.colors.foreground.default};
`
